import { init, track, setUserId } from '@amplitude/analytics-browser';

// Initialize Amplitude with your API key
const AMPLITUDE_API_KEY = import.meta.env.VITE_AMPLITUDE_API_KEY;

// Initialize Amplitude
export const initAmplitude = () => {
  if (!AMPLITUDE_API_KEY) {
    console.warn('Amplitude API key not found. Analytics will not be tracked.');
    return;
  }
  
  init(AMPLITUDE_API_KEY, {
    defaultTracking: {
      sessions: true,
      pageViews: true,
      formInteractions: true,
      fileDownloads: true,
    },
  });
};

// Identify user in Amplitude
export const identifyUser = (userId: string, userProperties: {
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: string;
}) => {
  setUserId(userId);
  
  // Track the login event with user properties
  track('User Login', {
    user_id: userId,
    email: userProperties.email,
    first_name: userProperties.firstName,
    last_name: userProperties.lastName,
    role: userProperties.role,
  });
};

// Clear user identification (for logout)
export const clearUserIdentification = () => {
  setUserId(undefined);
  
  // Track the logout event
  track('User Logout');
};

// Track custom events
export const trackEvent = (eventName: string, eventProperties?: Record<string, any>) => {
  track(eventName, eventProperties);
};

// Common event tracking functions
export const trackPageView = (pageName: string, pageProperties?: Record<string, any>) => {
  track('Page View', {
    page_name: pageName,
    ...pageProperties,
  });
};

export const trackUserAction = (action: string, properties?: Record<string, any>) => {
  track('User Action', {
    action,
    ...properties,
  });
};

export const trackError = (error: string, errorDetails?: Record<string, any>) => {
  track('Error', {
    error_message: error,
    ...errorDetails,
  });
};

export const trackConversion = (conversionType: string, value?: number, properties?: Record<string, any>) => {
  track('Conversion', {
    conversion_type: conversionType,
    value,
    ...properties,
  });
}; 